<aside *ngIf="routeData?.hasSecondarySidebar"
       class="db-website-sidebar"
       [ngClass]="{
          'has-banner': !!hasBanner,
          'db-with-ph-banner': (sidebarNavigationService.isProductHuntBannerVisible|async) && !passwordProtection,
          'db-with-site-lock-ph': (sidebarNavigationService.isProductHuntBannerVisible|async) && !!passwordProtection,
          'db-website-sidebar-with-pp': routeData?.hasSecondarySidebar && this.website?.domain_hash && website?.type === 'live' &&
          ((website && !website.isAiBuilderDemo)
            || (userSubscription?.type === userSubscriptionTypes?.PLATFORM && !(hasPayments || primaryChanged)))
       }">
  <div *ngIf="website" class="db-website-sidebar__thumb">
    <db-website-item-menu [ngStyle]="website?.parentId && {'borderTop': '1px solid rgba(255, 255, 255, 0.1)'}"
                          [website]="website" [hideManageButton]="true"
                          [class.password-protected]="!!passwordProtection"
                          [user]="user"
                          [parentWebsite]="parentWebsite" [networkSubsites]="networkSubSites"
                          [currentSubscription]="userSubscription"></db-website-item-menu>
  </div>
  <div class="db-website-sidebar__aha"
       *ngIf="user && (user.hosting_services || (user.hasHostingTrial && !user.hostingTrialExpired))
       && !disableCopyWebsite && website && !website?.isNetwork && website?.type === 'live'
       && ( website.connectedFrom !== 'speed_optimizer' && !userSubscription?.plan?.services?.speed_optimizer)">
    <a class="db-website-sidebar__copy-site" (click)="sendAnalyticsEvent()"
       [routerLink]="['websites/' + website?.id + '/pageSpeed']"
       routerLinkActive="db-website-sidebar__nav-menu_item_active">
      <span *ngIf="!!website?.domain_hash" [innerHTML]="'text_performance.pageSpeedOptimizeWebsite90+' | dbText"></span>
      <span *ngIf="!website?.domain_hash" [innerHTML]="'text_performance.pageSpeedCopyWebsite90+' | dbText"></span>
    </a>
  </div>
  <div class="db-website-sidebar_wrap" id="db-sidebar-body">

    <a
      *ngIf="userSubscription?.trialBoosterClient && !userSubscription?.isExpired"
      class="db-website-sidebar__outlined-item" [routerLink]="['/upgrade-plan']"
      (click)="upgrade(showPercentOffer && !fromGallery)">
      <i class="db-icon db-icon-ds-diamond"></i>
      <span>{{fromGallery ? ('text_upgradeToPro' | dbText) : showPercentOffer && !fromGallery ? ('text_getBoosterPro' | dbText) :
        ('text_tryBoosterForFree' | dbText)}}</span>
    </a>

    <ul class="db-website-sidebar__nav-menu noselect">
      <ng-container *ngFor="let item of sidebarItems">
        <li *ngIf="!item?.hidden">
          <a *ngIf="item.type === 'simple' && !item.disabled"
             class="db-website-sidebar__nav-menu_item"
             [ngClass]="{'db-website-sidebar__nav-menu_item_active': routerLink.includes('/websites/' + website?.id + item?.path)}"
             (click)="item.emitActions(); mobileAvailability(item.path)">
            <img *ngIf="item.img" [src]="item.img" alt="">
            <i *ngIf="item.icon" [ngClass]="['db-icon', item.icon]"></i>
            <span [innerHTML]="item.label | dbText"></span>
          </a>
          <span *ngIf="item.type === 'simple' && item.disabled"
                class="db-website-sidebar__nav-menu_item db-website-sidebar__nav-menu_item_disabled"
                [dsTooltip]="disableTooltip" dsTooltipPosition="right">
          <img *ngIf="item.img" [src]="item.img" alt="">
            <i *ngIf="item.icon" class="db-icon {{item.icon}}"></i>
          <span [innerHTML]="item.label | dbText"></span>
        </span>

          <div *ngIf="item.type === 'accordion'">
            <a class="db-website-sidebar__nav-menu_item db-website-sidebar__nav-menu_item_static">
              <img *ngIf="item.img" [src]="item.img" alt="">
              <i *ngIf="item.icon" class="db-icon {{item.icon}}"></i>
              <span [innerHTML]="item.label | dbText"></span>
            </a>
            <ul class="db-website-sidebar__sub-menu db-website-sidebar__sub-menu_accordion"
                [ngClass]="{'db-website-sidebar__sub-menu_accordion_expanded': item?.pageIds && item?.pageIds.includes(routeData?.data?.pageId)}">
              <li *ngFor="let subItem of item?.subMenu">
                <a *ngIf="!subItem.disabled"
                   class="db-website-sidebar__sub-menu_item"
                   [ngClass]="{'db-website-sidebar__sub-menu_item_active': routerLink === '/websites/' + website?.id + subItem?.path}"
                   (click)="subItem.emitActions(); mobileAvailability(subItem.path)">
                  <img *ngIf="subItem.img && !subItem.icon" [src]="subItem.img" alt="">
                  <i *ngIf="subItem.icon" class="db-icon {{subItem.icon}}"></i>
                  <span [innerHTML]="subItem.label | dbText"></span>
                </a>
                <span *ngIf="subItem.disabled"
                      class="db-website-sidebar__sub-menu_item db-website-sidebar__sub-menu_item_disabled"
                      [dsTooltip]="disableTooltip" dsTooltipPosition="right">
                <img *ngIf="subItem.img && !subItem.icon" [src]="subItem.img" alt="">
                <i *ngIf="subItem.icon" class="db-icon {{subItem.icon}}"></i>
                <span [innerHTML]="subItem.label | dbText"></span>
              </span>
              </li>
            </ul>
            <a *ngIf="item.subMenu.length > 3"
               class="db-website-sidebar__sub-menu_item db-website-sidebar__sub-menu_item_toggle"
               [ngClass]="{'db-website-sidebar__sub-menu_item_toggle_expanded': item?.pageIds && item?.pageIds.includes(routeData?.data?.pageId)}"
               dbLoaded (loaded)="item.toggle(routeData.data.pageId)"
               (click)="item.toggle()">
              <span [innerHTML]="item?.pageIds && item?.pageIds.includes(routeData?.data?.pageId) ? 'less' : 'more'"></span>
              <i class="db-icon db-icon-ds-arrow-sharp"></i>
            </a>
          </div>

          <div *ngIf="item.type === 'static'">
            <a class="db-website-sidebar__nav-menu_item db-website-sidebar__nav-menu_item_static">
              <img *ngIf="item.img" [src]="item.img" alt="">
              <i *ngIf="item.icon" class="db-icon {{item.icon}}"></i>
              <span [innerHTML]="item.label | dbText"></span>
            </a>
            <ul class="db-website-sidebar__sub-menu">
              <li *ngFor="let subItem of item.subMenu">
                <a class="db-website-sidebar__sub-menu_item"
                   [ngClass]="{'db-website-sidebar__sub-menu_item_active': routerLink === '/websites/' + website?.id + subItem?.path}"
                   (click)="subItem.emitActions(); mobileAvailability(subItem.path)">
                  <img *ngIf="subItem.img && !subItem.icon" [src]="subItem.img" alt="">
                  <i *ngIf="subItem.icon" class="db-icon {{subItem.icon}}"></i>
                  <span [innerHTML]="subItem.label | dbText"></span>
                </a>
              </li>
            </ul>
          </div>

          <div *ngIf="item.type === 'dropdown'">
            <a class="db-website-sidebar__nav-menu_item db-website-sidebar__nav-menu_item_dropdown"
               [ngClass]="{'db-website-sidebar__nav-menu_item_dropdown_expanded': item?.isExpanded,
                'db-website-sidebar__nav-menu_item_dropdown_active': item?.pageIds && item?.pageIds.includes(routeData?.data?.pageId)}"
               dbLoaded (loaded)="item.toggle(routeData?.data?.pageId)"
               (click)="item.isExpanded = !item.isExpanded; $event.stopPropagation()">
              <img *ngIf="item.img" [src]="item.img" alt="">
              <i *ngIf="item.icon" [ngClass]="['db-icon', item.icon]">
              </i>
              <div>
                <span [innerHTML]="item.label | dbText">
                </span>
                <i class="db-icon db-icon-ds-arrow-sharp"></i>
              </div>
            </a>
            <ul class="db-website-sidebar__sub-menu db-website-sidebar__sub-menu_dropdown"
                [ngClass]="{'db-website-sidebar__sub-menu_dropdown_expanded': item?.isExpanded}">
              <li *ngFor="let subItem of item.subMenu">
                <a class="db-website-sidebar__sub-menu_item" *ngIf="subItem?.externalLink"
                   (click)="sendRedirectEcommerceEvents(subItem?.label)"
                   dbWpLink [adminLink]="website?.adminEcommerceUrls[subItem.name]" [websiteId]="website?.id" target="_blank" rel="noopener">
                  <img *ngIf="subItem.img && !subItem.icon" [src]="subItem.img" alt="">
                  <span [innerHTML]="subItem.label | dbText"></span>
                  <i *ngIf="subItem.icon" class="db-icon {{subItem.icon}}"></i>
                </a>
                <a class="db-website-sidebar__sub-menu_item {{subItem?.path}} {{routerLink}}" *ngIf="!subItem?.externalLink"
                   [ngClass]="{'db-website-sidebar__sub-menu_item_active':  routerLink.includes('/websites/' + website?.id + subItem?.path)}"
                   (click)="subItem.emitActions(); mobileAvailability(subItem.path)">
                  <img *ngIf="subItem.img && !subItem.icon" [src]="subItem.img" alt="">
                  <span [innerHTML]="subItem.label | dbText"></span>
                  <i *ngIf="subItem.icon" class="db-icon {{subItem.icon}}"></i>
                </a>
              </li>
            </ul>
          </div>
        </li>

      </ng-container>
    </ul>
    <!--   advanced elements part --->
    <ng-container *ngIf="!!website?.domain_hash && advancedSidebarItems?.length > 0">
      <div class="db-website-sidebar__advanced {{showAdvanced}}" (click)="toggleAdvancedSection()">

        <div class="db-advanced-label">
          <span><i class="db-icon db-icon-ds-sidebar-advanced"></i>{{'text_advancedSection' | dbText}}</span>
          <a class="db-button-advanced"
          ><span>{{showAdvanced ? ('text_hideToggle' | dbText) : ('text_showToggle' | dbText)}}</span></a>
        </div>

      </div>
      <ul class="db-website-sidebar__nav-menu advanced noselect"
          #advancedMenuRef
          *ngIf="!!showAdvanced">
        <ng-container *ngFor="let item of advancedSidebarItems">
          <li *ngIf="!item?.hidden">
            <a *ngIf="item.type === 'simple' && !item.disabled"
               class="db-website-sidebar__nav-menu_item"
               [ngClass]="{'db-website-sidebar__nav-menu_item_active':routerLink.includes('/websites/' + website?.id + item?.path)}"
               (click)="item.emitActions(); mobileAvailability(item.path)">
              <img *ngIf="item.img" [src]="item.img" alt="">
              <i *ngIf="item.icon" [ngClass]="['db-icon', item.icon]"></i>
              <span [innerHTML]="item.label | dbText"></span>
            </a>
            <span *ngIf="item.type === 'simple' && item.disabled"
                  class="db-website-sidebar__nav-menu_item db-website-sidebar__nav-menu_item_disabled"
                  [dsTooltip]="disableTooltip" dsTooltipPosition="right">
            <img *ngIf="item.img" [src]="item.img" alt="">
              <i *ngIf="item.icon" class="db-icon {{item.icon}}"></i>
            <span [innerHTML]="item.label | dbText"></span>
          </span>

            <div *ngIf="item.type === 'dropdown'">
              <div class="db-website-sidebar__nav-menu_item db-website-sidebar__nav-menu_item_static">
                <img *ngIf="item.img" [src]="item.img" alt="">
                <i *ngIf="item.icon" [ngClass]="['db-icon', item.icon]">
                </i>
                <span [innerHTML]="item.label | dbText"></span>
              </div>
              <ul class="db-website-sidebar__sub-menu db-website-sidebar__sub-menu_dropdown db-website-sidebar__sub-menu_dropdown_expanded">
                <li *ngFor="let subItem of item.subMenu">
                  <a class="db-website-sidebar__sub-menu_item" *ngIf="subItem?.externalLink"
                     (click)="sendRedirectEcommerceEvents(subItem?.label)"
                     dbWpLink [adminLink]="website?.adminEcommerceUrls[subItem.name]" [websiteId]="website?.id" target="_blank" rel="noopener">
                    <img *ngIf="subItem.img && !subItem.icon" [src]="subItem.img" alt="">
                    <span [innerHTML]="subItem.label | dbText"></span>
                    <i *ngIf="subItem.icon" class="db-icon {{subItem.icon}}"></i>
                  </a>
                  <a class="db-website-sidebar__sub-menu_item" *ngIf="!subItem?.externalLink && !subItem?.showUpgrade"
                     [ngClass]="{'db-website-sidebar__sub-menu_item_active': routerLink.includes('/websites/' + website?.id + subItem?.path)}"
                     (click)="subItem.emitActions(); mobileAvailability(subItem.path)">
                    <img *ngIf="subItem.img && !subItem.icon" [src]="subItem.img" alt="">
                    <span [innerHTML]="subItem.label | dbText"></span>
                    <i *ngIf="subItem.icon" class="db-icon {{subItem.icon}}"></i>
                  </a>
                  <a class="db-website-sidebar__sub-menu_item db-website-sidebar__upgrade-locked-4" *ngIf="!subItem?.externalLink && subItem?.showUpgrade"
                     [routerLink]="['/upgrade-plan']">
                    <img *ngIf="subItem.img && !subItem.icon" [src]="subItem.img" alt="">
                    <span [innerHTML]="subItem.label | dbText"></span>
                    <i *ngIf="subItem.icon" class="db-icon {{subItem.icon}}"></i>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ng-container>
      </ul>
    </ng-container>
    <!--   advanced elements part end --->
  </div>

  <div class="db-website-sidebar_wrap__add-website"
       *ngIf="userSubscription?.trialBoosterClient && !website?.domain_hash">
    <p><b>{{'text_optimizeMoreWebsites' | dbText}}</b></p>
    <p class="mt4">{{'text_haveMoreWebsitesToOptimize' | dbText}}</p>
    <button class="ds-btn-black ds-btn-medium ds-btn-max mt15" (click)="optimizeWebsite()">
      <span>{{'text_sideBarAddWebsite' | dbText}}</span>
    </button>
  </div>
</aside>

<ng-template #disableTooltip>
  <p>{{'text_featureAvailableToPaidPlans' | dbText}}<br> <a [routerLink]="['/upgrade-plan']">{{'text_upgrade' | dbText}}</a></p>
</ng-template>
